import { computed, unref, type MaybeRef } from "vue";
import { createQuery } from "@/queries";
import { getRecommendationsCollections, type Audience } from "@/features/recommendations/api/recommendations";
import type { AxiosResponse } from "axios";
import type { RecommendationsCollectionsResponse } from "@/types/recommendations";
import type { ProductCustomCardItem } from "@/types/ProductType";

type RecommendationsCollectionsResponseData = Awaited<
  ReturnType<typeof getRecommendationsCollections>
> extends AxiosResponse<infer T>
  ? T
  : never;

export const useRecommendationsCollectionsQuery = (
  limit: MaybeRef<number>,
  audience: MaybeRef<Audience>
) => {
  return createQuery<RecommendationsCollectionsResponseData>({
    key: computed(() => ["recommendations", "collections", unref(limit), unref(audience)]),
    fetcher: async () => {
      const response = await getRecommendationsCollections(unref(limit), unref(audience));
      return response.data;
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
};

